import { render, staticRenderFns } from "./GisogdSectionCard.vue?vue&type=template&id=0135999d&scoped=true&"
import script from "./GisogdSectionCard.vue?vue&type=script&lang=js&"
export * from "./GisogdSectionCard.vue?vue&type=script&lang=js&"
import style0 from "./GisogdSectionCard.vue?vue&type=style&index=0&id=0135999d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0135999d",
  null
  
)

export default component.exports